<template>
  <div class="Signature">
    <div class="header">
      <span class="iconfont icon-back" @click="Back"></span>
      <span class="title">合同签名</span>
    </div>
    <canvas class="canvasId" />
    <div class="btn">
      <div class="back" @click="Back">返回</div>
      <div class="clear" @click="Clear">清除</div>
      <div class="save" @click="Save">保存</div>
    </div>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";
export default {
  data() {
    return {
      signaturePad: null,
      config: {
        penColor: "black", //笔刷颜色
        minWidth: 3 //最小宽度
      },
      orderId: "",
      resolutionType: "",
      IsWill:"",
    };
  },
  methods: {
    Clear() {
      //清除画布内容
      this.signaturePad.clear();
    },
    Save() {
      let _self = this;
      if (_self.signaturePad.isEmpty()) {
        _self.$messagebox({
          title: "提示",
          message: "您还未签名"
        });
      } else {
        let param = {
          orderId: _self.orderId,
          resolutionType: _self.resolutionType,
          IsWill:_self.IsWill,
        };
        var formData = new FormData();
        Object.keys(param).forEach(key => {
          formData.append(key, param[key]);
        });
        let time = Date.parse(new Date());
        formData.append(
          "signature",
          _self.ConvertBase64UrlToBlob(_self.signaturePad.toDataURL()),
          "游客签名" + time + ".png"
        );
        _self.axios
          .post("/api/tourist/Itineraries/SaveOneDayContact", formData)
          .then(res => {
            sessionStorage.removeItem("Vue_OrderId");
            sessionStorage.removeItem("Vue_ResolutionType");
            _self
              .$messagebox({
                title: "提示",
                message: "签名成功"
              })
              .then(res => {
                _self.$router.push("/HomePage");
                // _self.$router.go(-1);
              });
          })
          .catch(err => {});
      }
    },
    Init() {
      let canvas = document.querySelector(".canvasId");
      this.signaturePad = new SignaturePad(canvas, this.config);
      canvas.height = 500;
      canvas.width = document.body.clientWidth * 0.8;
    },
    Back() {
      let _self = this;
      // this.$router.back();
     _self.$router.push({
          name: "MainContact",
          params: {
            orderId: _self.orderId,
            resolutionType: _self.resolutionType
          }
      });
    },
    ConvertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte

      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], { type: "image/png" });
    }
  },
  mounted() {
    let _self = this;
    if (
      sessionStorage.getItem("Vue_OrderId") == null &&
      _self.$route.params.orderId == null &&
      sessionStorage.getItem("Vue_ResolutionType") == null &&
      _self.$route.params.resolutionType == null &&
      _self.$route.params.IsWill==null
    ) {
      _self.$router.push("/HomePage");
    } else {
      _self.orderId =
        _self.$route.params.orderId != null
          ? _self.$route.params.orderId
          : sessionStorage.getItem("Vue_OrderId");

      _self.resolutionType =
        _self.$route.params.resolutionType != null
          ? _self.$route.params.resolutionType
          : sessionStorage.getItem("Vue_ResolutionType");

      _self.IsWill= _self.$route.params.IsWill;
      _self.Init();
    }



  }
};
</script>

<style lang="less" scoped>
.Signature {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;

  -webkit-touch-callout: none;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;

  .header {
    background: white;
    padding: 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    text-align: center;
    position: relative;

    .iconfont {
      position: absolute;
      left: 30px;
      top: 20px;
      font-size: 34px !important;
    }
    .title {
      font-size: 34px !important;
      letter-spacing: 3px;
    }
  }
  .canvasId {
    border: 2px solid #ddd;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .btn {
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    font-size: 30px;
    letter-spacing: 3px;

    div {
      flex: 1 0 auto;
      margin: 0 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      border-radius: 5px;
      color: white;
      outline: none;
    }
    .back {
      background: #909399;
    }
    .clear {
      background: #e6a23c;
    }
    .save {
      background: #67c23a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signature.vue